import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';

import {count} from '@evag/ec-react';

import styles from './BarCounter.module.scss';

const delay = 50;
const parts = 20;

const calculateGoal = (number) => {
  if (number < 100) {
    return 100;
  }

  for (let e = 2; ; e++) {
    if (number < Math.pow(10, e)) {
      const p = Math.pow(10, e - 1);
      return Math.floor((number + p) / p) * p;
    }
  }
};

const numberFormat = (number) => {
  try {
    return new Intl.NumberFormat('pt-BR').format(number);
  } catch (_) {
    return number;
  }
};

class BarCounter extends React.Component {
  constructor(props) {
    super(props);

    this.setCount = this.setCount.bind(this);

    this.state = {
      count: 0,
      error: false,
      loading: true,
      goal: 100,
    };
  }

  setCount(number) {
    const goal = calculateGoal(number);

    this.setState({
      goal: goal,
    });

    for (let i = 0; i < parts; i++) {
      window.setTimeout(() => {
        this.setState({
          count: Math.floor(((i + 1) * number) / parts),
        });
      }, (i + 1) * delay);
    }
  }

  componentDidMount() {
    count(this.props.channelId)
      .then((res) => {
        this.setCount(res.data.count);
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          error: true,
        });
      })
      .then(() => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    if (this.state.loading) {
      return <Loader type="BallTriangle" color="#fff" height="40" width="40" />;
    }

    if (this.state.error) {
      return null;
    }

    const width = `${(100.0 * this.state.count) / this.state.goal}%`;

    const bar = (
      <div className={styles.bar}>
        <div className={styles.current} style={{width: width}} />
      </div>
    );

    const text = (
      <p>
        {numberFormat(this.state.count)} pessoas já{' '}
        {this.props.verb || 'assinaram'}.{` `}
        Ajude-nos a chegar a {numberFormat(this.state.goal)}!
      </p>
    );

    return this.props.bar ? (
      <div className={styles.container}>
        {bar}
        {text}
      </div>
    ) : (
      text
    );
  }
}

BarCounter.defaultProps = {
  bar: true,
};

BarCounter.propTypes = {
  bar: PropTypes.bool,
  channelId: PropTypes.string.isRequired,
};

export default BarCounter;
